import { on } from 'delegated-events'

const topBar = document.querySelector('.site-announcement')

const fn = {
    init: () => {
        on('click', '.site-announcement-close', fn.handleClose)

        window.addEventListener('resize', fn.setHeight)
        fn.setHeight()
    },

    handleClose: () => {

        let el = document.getElementsByClassName('header_action_wrp')
        if (el.length > 0) {
            el[0].style.top = 0;
        }
        // let elSide = document.getElementsByClassName('header-side-panel')
        // if (elSide.length > 0) {
        //     elSide[0].style.top = 0;
        // }

        let el1 = document.getElementsByClassName('header-blue')
        if (el1.length > 0) {
            el1[0].style.marginTop = "3.5rem";
        }
        topBar.remove();
        fn.setHeight();
    },

    setHeight: () => {
        document.documentElement.style.setProperty('--site-announcement-height', `${topBar.offsetHeight}px`);
    },
}

export default {
    can: () => topBar,
    run: fn.init,
}